module.exports = __webpack_public_path__ + "img/api-okex.4039485c.png";